import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../common/html/element'
import { Icon } from '../../../../common/html/icon'
import { selectCompanyInfo } from '../../header/companyInfo/store/slice'
import { types } from '../constant'
import Count from './Count'
import classes from './index.module.scss'
import InputSearchTemplate from './InputSearchTemplate'
import {
  changeTemplates,
  changeTypeTemplate,
  selectTypeTemplate,
} from './store/slice'
import TableTemplate from './TableTemplate'

const Templates = ({
  backToDetailTemplate,
  template,
  openTemplate,
  setIsShowDetail,
}) => {
  const dispatch = useDispatch()

  const {
    data,
    callApi,
    callApiSearch,
    loading,
    total,
    idKey,
    nameKey,
    deleteTemplate,
    setDefaultTemplate,
    updateTemplate,
    callApiDefaultTemplate,
    defaultTemplate,
    loadingSearch,
    dataTemplateSearch,
    typeCompanyDisable = [],
  } = template

  const companyInfo = useSelector(selectCompanyInfo)
  const typeTemplate = useSelector(selectTypeTemplate)

  useEffect(() => {
    if (!typeTemplate) {
      setTypeTemplate(types[companyInfo.companyType]?.value)
    }
  }, [companyInfo.companyType])

  useEffect(() => {
    dispatch(changeTemplates({ data, idKey }))
  }, [data])

  const setTypeTemplate = (val) => dispatch(changeTypeTemplate(val))

  return (
    <Element style={{ color: '#3A414B' }} className={classes.templateContainer}>
      <div>
        <Element
          style={{ border: '1px solid #D5D5D5' }}
          className={classes.btnBack}
          onClick={backToDetailTemplate}
        >
          <Icon className="icon-arrow-left" style={{ fontSize: 8 }} />
          <Translate value="preferenceSetting.BACK_SETTING" />
        </Element>
        <Element
          style={{ fontSize: 24, color: '#0553A5' }}
          className={classes.title}
        >
          <Translate value="preferenceSetting.ALL_TEMPLATE" />
        </Element>
      </div>
      <div className={classes.inputContainer}>
        <div className={classes.w320}>
          <InputSearchTemplate
            callApiSearch={callApiSearch}
            loadingSearch={loadingSearch}
            dataTemplateSearch={dataTemplateSearch}
            nameKey={nameKey}
            openTemplate={openTemplate}
            setIsShowDetail={setIsShowDetail}
            isOpenAll={true}
          />
        </div>
        <div className={`dFlex ${classes.mt12}`}>
          {Object.keys(types).map((key) => {
            const type = types[key]

            const isActive = typeTemplate === type.value

            const isDisable = typeCompanyDisable.includes(type.value)

            const styleDisable = isDisable ? { opacity: 0.4 } : {}

            return (
              <Element
                style={
                  !isActive
                    ? { background: '#F3F3F3', ...styleDisable }
                    : {
                        background: '#2C73E8',
                        color: '#FFFFFF',
                        ...styleDisable,
                      }
                }
                key={type.value}
                className={classes.typeTab}
                onClick={
                  !isDisable ? () => setTypeTemplate(type.value) : undefined
                }
              >
                <Translate value={type.title} />
              </Element>
            )
          })}
        </div>
      </div>
      <div className={classes.mt12}>
        <Count
          deleteTemplate={deleteTemplate}
          typeTemplate={typeTemplate}
          total={total}
          defaultTemplate={defaultTemplate}
          idKey={idKey}
        />
      </div>
      <TableTemplate
        typeTemplate={typeTemplate}
        callApiTemplates={callApi}
        loading={loading}
        total={total}
        nameKey={nameKey}
        deleteTemplate={deleteTemplate}
        openTemplate={openTemplate}
        setDefaultTemplate={setDefaultTemplate}
        idKey={idKey}
        updateTemplate={updateTemplate}
        callApiDefaultTemplate={callApiDefaultTemplate}
        defaultTemplate={defaultTemplate}
      />
    </Element>
  )
}

export default Templates
